"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function GoogleAnalyticsZero() {
    return {
        event: '',
        eventAction: '',
        eventCategory: '',
        eventContent: '',
        eventContext: '',
        eventFormVersion: '',
        eventLabel: '',
        eventVendor: '',
        eventProduct: '',
        eventData: '',
        eventContextMessage: '',
        eventError: '',
        eventSuccess: '',
        eventSection: '',
        eventSubSection: '',
        eventPositionSubSection: '',
        eventPositionElement: ''
    };
}
exports.default = GoogleAnalyticsZero;
